<template>
  <div id="update-password-page">
    <h2 class="intro-y text-lg font-medium mt-10">
      更改密碼
    </h2>

    <password-form></password-form>
  </div>
</template>

<script>
export default {
  props: ['auth', 'currentSite'],
  data() {
    return {
      mounted: false
    }
  },
  watch: {
    auth(val) {
      if (val) {
        this.init()
      }
    },
    currentSite() {
      this.init()
    }
  },
  async mounted() {
    if (!this.auth) {
      return
    }

    await this.init()
  },
  methods: {
    async init() {
      if (this.currentSite) {
        this.mounted = true
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
